'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useCommandPaletteContext } from './use-command-palette-context';

export function SearchPageAutoOpen(): null {
  const params = useSearchParams();
  const { openPalette } = useCommandPaletteContext();
  const opened = useRef(false);

  useEffect(() => {
    if (opened.current) {
      return;
    }
    const q = params.get('q');
    if (q !== null) {
      opened.current = true;
      openPalette(q);
    }
  }, [params, openPalette]);

  return null;
}
